import type { CustomerConfig } from '@peanuds/app-shell';
import type { RegistrationCountry } from '@peanuds/shared';
import totalBalancePromoVideo from './assets/media/total-balance/bebawa-promo.mp4';

const BEBAWA_SUPPORTED_COUNTRIES = [
  'AD',
  'AE',
  'AL',
  'AM',
  'AT',
  'AZ',
  'BA',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GE',
  'GR',
  'HK',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MD',
  'ME',
  'MK',
  'MT',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RS',
  'SE',
  'SG',
  'SI',
  'SK',
  'SM',
  'TR',
  'VA',
] as const satisfies readonly RegistrationCountry[];

/**
 * Bebawa customer-specific configuration.
 *
 * This is the single source of truth for all customer-specific values
 * that features need at runtime (legal links, branding assets, etc.).
 *
 * Provided to the Vue app via `app.provide(CUSTOMER_CONFIG_KEY, customerConfig)`
 * in main.ts, and consumed by features via `useCustomerConfig()`.
 */
export const customerConfig: CustomerConfig = {
  links: {
    serviceAgreement: 'https://www.bebawa.com/legal',
    privacyPolicy: 'https://www.bebawa.com/legal',
  },
  media: {
    totalBalancePromoMedia: {
      src: totalBalancePromoVideo,
      type: 'video',
    },
  },
  countries: {
    registration: BEBAWA_SUPPORTED_COUNTRIES,
  },
  notifications: {
    novuContext: {
      tenant: {
        id: 'bebawa',
        data: {
          applicationName: 'Bebawa',
        },
      },
    },
  },
  dateTime: {
    locale: 'en-GB',
  },
  currency: {
    transactionAmount: {
      pattern: '{sign} {currencySymbol}{amount}',
      locale: 'de-DE',
    },
  },
};
